"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("../../environments/environment");
var resource_service_1 = require("../shared/resource.service");
var http_1 = require("@angular/common/http");
var stats_job_event_filter_serializer_1 = require("./stats-job-event.filter.serializer");
var StatsJobEventFilterService = /** @class */ (function (_super) {
    __extends(StatsJobEventFilterService, _super);
    function StatsJobEventFilterService(http) {
        var _this = _super.call(this, http, 'jobevents/stats', new stats_job_event_filter_serializer_1.StatsJobEventFilterSerializer()) || this;
        _this.baseUrl = environment_1.environment.serverUrl;
        return _this;
    }
    return StatsJobEventFilterService;
}(resource_service_1.ResourceService));
exports.StatsJobEventFilterService = StatsJobEventFilterService;
